import window from './window.js';

export default window.fetch;
